module.exports = __webpack_public_path__ + "static/media/logo-white.cf0e3674.svg";